import React from "react";
import { Link } from "react-router-dom";

function UIComponentsPage({ utente }) {
  if (!utente?.permessiAPI?.["read:debug"]) {
    return (
      <div className="pa2 pa3-ns">
        <div className="sfondoBiancoTema br3 pa3">
          <h3 className="mt0 mb2">Componenti UI</h3>
          <p className="mb0 dark-red">
            Non hai i permessi per visualizzare questa pagina.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="pa2 pa3-ns">
      <div className="mw8 center">
        <div className="sfondoBiancoTema br3 pa3 pa4-l">
          <h1 className="mt0 mb2">Componenti UI</h1>
          <p className="mt0 mb4 dark-gray">
            Area di documentazione interna per i componenti condivisi del
            frontend Domino.
          </p>
          <div className="flex flex-wrap">
            <div className="w-100 w-50-l pa2">
              <div className="ba b--black-10 br3 pa3 h-100">
                <div className="f4 b mb2">Skeleton</div>
                <p className="mt0 mb3 dark-gray">
                  Placeholder standard con shimmer, tone configurabili ed esempi
                  di utilizzo.
                </p>
                <Link
                  to="/ui-components-skeleton"
                  className="dib pointer bn br2 ph3 pv2 no-underline bg-dark-blue white"
                >
                  Apri documentazione Skeleton
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UIComponentsPage;
